<template lang="">
  <div class="news_r_b">
    <div class="text-center margin-bottom" style="font-size: 17px;">
      网站办理留言情况统计
    </div>
    <table border="" cellspacing="" cellpadding="">
      <tr>
        <th>年份</th>
        <th>收件数量</th>
        <th>处理数量</th>
        <th>未处理数量</th>
      </tr>
      <tr v-for="(item, index) in lytongjis" :key="index">
        <td>{{ item.yearmonth }}</td>
        <td>{{ item.chuli }}</td>
        <td>{{ item.chuli }}</td>
   
        <td v-if='item.weichuli == 0'> 0</td>
        <td v-else style="color: #5050c6"> 0</td>
      </tr>
    </table>
  </div>
</template>
<script>
import { lytongji } from "@/api/gxq";
export default {
  name: "Statistics",
  data() {
    return {
      lytongjis: [],
    };
  },
  mounted() {
    this.lytongji2();
  },
  methods: {
    async lytongji2() {
      const { data } = await lytongji();
      this.lytongjis = data;
    },
  },
};
</script>
<style scoped>
/* 新加的留言统计 */
table {
  width: 100%;
  min-height: 25px;
  line-height: 62px;
  text-align: center;
  border-collapse: collapse;
  color: #454545;
  font-size: 14px;
}
table,
table tr th,
table tr td {
  border: 1px solid #ccc;
}
table {
  margin-bottom: 10px;
  border-collapse: collapse;
  display: table;
}
/* 新加的留言统计结束 */
</style>
